import { render } from "./LimitBlock.vue?vue&type=template&id=2c15167a"
import script from "./LimitBlock.vue?vue&type=script&lang=js"
export * from "./LimitBlock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__